import {z} from 'zod';

/**
 * Constants for use case type values
 */
export const SCAN_VIN = 'scanVIN' as const;
export const SCAN_LICENSE_PLATE = 'scanLicensePlate' as const;
export const EXTRACT_DELIVERY_NOTE_DOCUMENT = 'extractDeliveryNoteDocument' as const;

/**
 * Zod schema for synchronous use cases that execute immediately and return results directly
 */
export const synchronousUseCaseTypeSchema = z.enum([SCAN_VIN, SCAN_LICENSE_PLATE]);

/**
 * @description Synchronous use cases that execute immediately and return results directly
 */
export type SynchronousUseCaseType = z.infer<typeof synchronousUseCaseTypeSchema>;

/**
 * Zod schema for asynchronous use cases that are processed via messaging queues
 */
export const asynchronousUseCaseTypeSchema = z.enum([EXTRACT_DELIVERY_NOTE_DOCUMENT]);

/**
 * @description Asynchronous use cases that are processed via messaging queues
 */
export type AsynchronousUseCaseType = z.infer<typeof asynchronousUseCaseTypeSchema>;

/**
 * Zod schema for all available use case types in the system
 */
export const useCaseTypeSchema = z.union([
  synchronousUseCaseTypeSchema,
  asynchronousUseCaseTypeSchema,
]);

/**
 * @description Union type of all available use case types in the system
 */
export type UseCaseType = z.infer<typeof useCaseTypeSchema>;
